import React from "react";
import MaterialTable from 'material-table';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import LocalHospital from "@material-ui/icons/LocalHospital";
import Close from "@material-ui/icons/Close";
import Search from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

import Subscriptions from "views/Components/Subscriptions"

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import axios from "axios";
import { getApiHeaders, addressToOneLine, phoneToDisplay, handleApiResponse } from "../../assets/helpers/apiHelper";
import { API_ROOT } from 'api-config';
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import Select from "@material-ui/core/Select/Select";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";

import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx";

const tableStyle = require('../../assets/style/tableStyle.json');
var tableOptions = require('../../assets/style/tableOptions.json');
tableOptions = JSON.parse(JSON.stringify(tableOptions));
var primaryDentistTableOptions = JSON.parse(JSON.stringify(tableOptions));
primaryDentistTableOptions.pageSize = 5;
primaryDentistTableOptions.toolbar = false;
primaryDentistTableOptions.paging = false;
var shortTableOptions = JSON.parse(JSON.stringify(tableOptions));
shortTableOptions.pageSize = 5;
shortTableOptions.toolbar = false;
const usStateList = require('../../assets/selectLists/usStates.json');

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  ...sweetAlertStyle,
  ...customInputStyle
};

class ReactTables extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId = sessionStorage.getItem('userId')
    if (props.userId) {
      userId = props.userId
    }
    var editByOrg = false
    var possessiveNoun = ''
    if (props.editByOrg === true) {
      editByOrg = props.editByOrg
      possessiveNoun = "Patient's"
    }
    var inDialog = false
    var formControlMargin = 'none'
    var customInputStyle = ''
    if (props.inDialog) {
      inDialog = props.inDialog
      formControlMargin = 'none'
      customInputStyle = {marginTop: "14px"}
    }
    this.onSubmitProviderSearch = this.onSubmitProviderSearch.bind(this);
    this.updateProvider = this.updateProvider.bind(this);
    this.state = {
      userId: userId,
      searchData: [],
      providerFirstName: '',
      providerLastName: '',
      providerState: '',
      patientMainDentistTableData: [],
      patientMainDentistTableRows: 1,
      patientSpecialistsTableData: [],
      patientSpecialistsTableRows: 1,
      editByOrg: editByOrg,
      possessiveNoun: possessiveNoun,
      updateDialogueOpen: false,
      updateDialogueText: '',
      subscriptionDialogueOpen: false,
      alert: '',
      selectedProviderId: '',
      showProviderSearchResults: false,
      inDialog: inDialog,
      formControlMargin: formControlMargin,
      customInputStyle: customInputStyle
    }
  }
  componentDidMount() {
    this._isMounted = true;
    this.getPatientMainDentist()
    this.getPatientSpecialists()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getPatientMainDentist() {
    axios.get(`${API_ROOT}/provider/?userId=`+this.state.userId+`&isPrimary=1`, {headers: getApiHeaders()})
      .then(res => this.setMainDentist({responseMessage: res.data}));
  }

  getPatientSpecialists() {
    axios.get(`${API_ROOT}/provider/?userId=`+this.state.userId+`&isPrimary=0`, {headers: getApiHeaders()})
      .then(res => this.setSpecialists({responseMessage: res.data}));
  }

  setMainDentist(res) {
    if (this._isMounted) {
      this.setState({
        patientMainDentistTableRows: res.responseMessage.length,
        patientMainDentistTableData: res.responseMessage.map((prop, key) => {
          return {
            id: prop.userId,
            name: (<span id={"patientPrimaryDentist_"+prop.userId}>{prop.name}</span> ),
            address: addressToOneLine(prop.address1, prop.address2),
            addressCity: prop.city,
            addressState: prop.state,
            addressZip: prop.zip,
            phone: phoneToDisplay(prop.phone),
            actions: ''
          };
        }),

      });
    }
  }

  setSpecialists(res) {
    if (this._isMounted) {
      this.setState({
        patientSpecialistsTableRows: res.responseMessage.length,
        patientSpecialistsTableData: res.responseMessage.map((prop, key) => {
          return {
            id: prop.userId,
            name: prop.name,
            address: addressToOneLine(prop.address1, prop.address2),
            addressCity: prop.city,
            addressState: prop.state,
            addressZip: prop.zip,
            phone: phoneToDisplay(prop.phone),
            actions: (<Button
              color="danger"
              simple
              onClick={this.updateProvider.bind(this, prop.userId, 'remove', 0)}
              id={"removeSpecialist_" + prop.userId}
              name={"removeSpecialist_" + prop.userId}
            >
              <Close/>
            </Button>)
          };
        }),

      });
    }
  }


  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleChangeSelect = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  onSubmitProviderSearch(e) {
    e.preventDefault();
    this.setState({
      showProviderSearchResults: true,
      searchData: [{ id: 0, name: 'loading...', dentists: 'loading...',
        address: 'loading...', addressCity: 'loading...', addressState: 'loading...',
        addressZip: 'loading...', phone: 'loading...', actions: 'loading...' }]
    });
    axios.get(`${API_ROOT}/provider/?addressState=`+this.state.providerState+`&lastName=`+this.state.providerLastName+`&firstName=`+this.state.providerFirstName, {headers: getApiHeaders()})
      .then(res => this.setProviderSearchResponse({responseMessage: res.data}));

  }

  setProviderSearchResponse(res) {
    if (this._isMounted) {
      this.setState({
        searchData: res.responseMessage.map((prop, key) => {
          return {
            id: prop.userId,
            name: prop.name,
            dentists: JSON.parse(prop.linkedPeople).map((provider, key) => {
              return (<li key={key}>
                {provider.firstName} {provider.middleName} {provider.lastName}
                {provider.suffix !== "" ?
                  ', '
                  : ''}
                {provider.suffix}
                {provider.title !== "" ?
                  ', '
                  : ''}
                {provider.title}</li>)
              }),
            address: addressToOneLine(prop.address1, prop.address2),
            addressCity: prop.city,
            addressState: prop.state,
            addressZip: prop.zip,
            phone: phoneToDisplay(prop.phone),
            actions: (<div>
              <span style={!this.state.editByOrg ? {} : { display: 'none' }}>
                {/* use this button to add a edit kind of action */}
                <Button
                  color="success"
                  simple
                  onClick={this.updateProvider.bind(this, prop.userId, 'add', 1)}
                  id={"addPrimaryDentistButton_" + prop.userId}
                >
                        <AddIcon/>Primary
                      </Button>{" "}
                    </span>
              {/* use this button to add a edit kind of action */}
              <Button
                color="success"
                simple
                onClick={this.updateProvider.bind(this, prop.userId, 'add', 0)}
                id={"addSpecialistButton_" + prop.userId}
              >
                <AddIcon/>Specialist
              </Button>
            </div>)
          };
        })
      });
    }
  }

  updateProvider(providerId, updateAction, isPrimary, e) {
    if (this.state.editByOrg) {
      this.setState({
        updateDialogueOpen: true,
        updateDialogueText: "Please wait while we update the account."
      });
    }
    this.setState({
      selectedProviderId: providerId
    });
    const updateProviderData = {
      userId: this.state.userId,
      providerId: providerId,
      updateAction: updateAction,
      isPrimary: isPrimary
    }
    axios.post(`${API_ROOT}/provider/`, updateProviderData, {headers: getApiHeaders()})
      .then(res => this.handleUpdateProvidersResponse(res));
  }

  handleUpdateProvidersResponse(res) {
    if (this._isMounted) {
      if (res.data['error']) {
        if (res.data['error'] === 'invalid provider-subscription match') {
          this.setState({
            subscriptionDialogueOpen: true
          })

        } else {
          this.setState({
            updateDialogueOpen: false,
            updateDialogueText: "",
            subscriptionDialogueOpen: false,
            alert: (
              <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                title="problem updating provider"
                onConfirm={() => this.hideAlert()}
                confirmBtnCssClass={
                  this.props.classes.button + " " + this.props.classes.success
                }
                confirmBtnText="Okay"
                id="updateProviderAlert"
              >
                <span id="updateProviderAlertText">{res.data['error']}</span>
              </SweetAlert>)
          });
        }
      } else {
        handleApiResponse(res)
        this.getPatientMainDentist()
        this.getPatientSpecialists()
        this.setState({
          updateDialogueOpen: false,
          updateDialogueText: "",
          subscriptionDialogueOpen: false
        });
      }
    }
  }

  handleSubscriptionDialogClose = () => {
    this.setState({
      subscriptionDialogueOpen: false
    });
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        {this.state.alert}
        <Dialog
          open={this.state.updateDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
        >
          <DialogTitle id="form-dialog-title">updating linked providers</DialogTitle>
          <DialogContent>
            {this.state.updateDialogueText}
          </DialogContent>
        </Dialog>
        <Dialog
          open={this.state.subscriptionDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='lg'
        >
          <DialogTitle id="form-dialog-title">subscription information</DialogTitle>
          <DialogContent>
            The selected provider does not offer your current subscription. Please select a new subscription.
            <hr />
            <GridItem xs={12} sm={12} md={8}>
              <Card>
                <Subscriptions
                  userId={this.state.userId}
                  providerId={this.state.selectedProviderId}
                  updateAction='addForce'
                  isPrimary='1'
                  onPlanUpdate={this.updateProvider.bind(this)}
                />
              </Card>
            </GridItem>
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleSubscriptionDialogClose} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <GridItem xs={12}>
          <Card style={!this.state.editByOrg ? {} : { display: 'none' }}>
            <CardHeader color="cirrusBlue" icon>
              <CardIcon color="cirrusBlue">
                <LocalHospital />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{this.state.possessiveNoun} primary dentist</h4>
            </CardHeader>
            <CardBody>
              <MaterialTable
                title=''
                columns={[
                  { title: 'name', field: 'name'},
                  { title: 'address', field: 'address' },
                  { title: 'city', field: 'addressCity' },
                  { title: 'state', field: 'addressState' },
                  { title: 'zip', field: 'addressZip' },
                  { title: 'phone', field: 'phone' },
                  { title: '', field: 'actions' },
                ]}
                data={this.state.patientMainDentistTableData}
                options={primaryDentistTableOptions}
                style={tableStyle}
              />
            </CardBody>
          </Card>

          <Card>
            <CardHeader color="cirrusBlue" icon>
              <CardIcon color="cirrusBlue">
                <LocalHospital />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{this.state.possessiveNoun} specialists</h4>
            </CardHeader>
            <CardBody>
              <MaterialTable
                title=''
                columns={[
                  { title: 'name', field: 'name'},
                  { title: 'address', field: 'address' },
                  { title: 'city', field: 'addressCity' },
                  { title: 'state', field: 'addressState' },
                  { title: 'zip', field: 'addressZip' },
                  { title: 'phone', field: 'phone' },
                  { title: '', field: 'actions' },
                ]}
                data={this.state.patientSpecialistsTableData}
                options={shortTableOptions}
                style={tableStyle}
              />
            </CardBody>
          </Card>

          <Card>
            <CardHeader color="cirrusBlue" icon>
              <CardIcon color="cirrusBlue">
                <Search />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Search for a dentist</h4>
            </CardHeader>
            <CardBody>
              <form onSubmit={this.onSubmitProviderSearch}>
                <GridContainer>
                  <GridItem xs={6} sm={6} md={3}>
                    <CustomInput
                      labelText="First Name"
                      id="providerFirstName"
                      formControlProps={{
                        fullWidth: true,
                        margin: this.state.formControlMargin
                      }}
                      inputProps={{
                        onChange: this.handleChange,
                        value: this.state.providerFirstName
                      }}
                      customStyle={this.state.customInputStyle}
                      fixLabelAlignment={true}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3}>
                    <CustomInput
                      labelText="Last Name/Company Name"
                      id="providerLastName"
                      formControlProps={{
                        fullWidth: true,
                          margin: this.state.formControlMargin
                      }}
                      inputProps={{
                        onChange: this.handleChange,
                        value: this.state.providerLastName
                      }}
                      customStyle={this.state.customInputStyle}
                      fixLabelAlignment={true}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={2}>


                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                      onSubmit={this.onSubmitProviderSearch}
                    >
                      <InputLabel
                        htmlFor="simple-select"
                        className={classes.selectLabel + " " + classes.labelRootAlignmentFix}
                      >
                        state
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu
                        }}
                        classes={{
                          select: classes.select
                        }}
                        value={this.state.providerState}
                        onChange={this.handleChangeSelect}

                        inputProps={{
                          id: "providerState",
                          name: "providerState"

                        }}

                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem
                          }}
                        >
                          Choose state
                        </MenuItem>
                        {usStateList.map((usState) =>
                          <MenuItem classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }} key={usState.abbreviation} value={usState.abbreviation} >{usState.name}</MenuItem>
                        )}

                      </Select>
                    </FormControl>

                  </GridItem>
                  <Button id="searchProviderButton" color="cirrusBlue" className={classes.updateProfileButton} type="submit">
                    Search
                  </Button>
                </GridContainer>
              </form>
              <span style={this.state.showProviderSearchResults ? {} : { display: 'none' }}>
                <MaterialTable
                  title=''
                  columns={[
                    { title: 'name', field: 'name'},
                    { title: 'address', field: 'address' },
                    { title: 'city', field: 'addressCity' },
                    { title: 'state', field: 'addressState' },
                    { title: 'zip', field: 'addressZip' },
                    { title: 'phone', field: 'phone' },
                    { title: '', field: 'actions' },
                  ]}
                  data={this.state.searchData}
                  options={shortTableOptions}
                  style={tableStyle}
                />
              </span>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(styles)(ReactTables);
